import { render } from "./ResetPassword.vue?vue&type=template&id=e24d47f8"
import script from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=e24d47f8&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/passwordReset/ResetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e24d47f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e24d47f8', __exports__)) {
    console.log('reload')
    api.reload('e24d47f8', __exports__)
  }
  
  module.hot.accept("./ResetPassword.vue?vue&type=template&id=e24d47f8", () => {
    console.log('re-render')
    api.rerender('e24d47f8', render)
  })

}


export default __exports__